/**
 * @generated SignedSource<<0a1790e45e890d8e13c3d191b0732c11>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type McpSettingsPage_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PageWithBreadCrumbs_query">;
  readonly " $fragmentType": "McpSettingsPage_query";
};
export type McpSettingsPage_query$key = {
  readonly " $data"?: McpSettingsPage_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"McpSettingsPage_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "McpSettingsPage_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageWithBreadCrumbs_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "75b27e16713b4137d9bb079920f0f3ff";

export default node;
